module.exports = __webpack_public_path__ + "static/Pionowe-zasobniki-ciepłej-wody-ZWV-0743d87f75322649bcdf5f4fbff7f548.pdf";